

module.exports = __webpack_require__.stylable.create(
    "EmptyStateView1470909390",
    {"classes":{"root":"EmptyStateView1470909390__root","container":"EmptyStateView1470909390__container","TPAText":""},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "EmptyStateView1470909390",
    null
);
